import { render, staticRenderFns } from "./Pa3.vue?vue&type=template&id=1c36cfd2&scoped=true"
import script from "./Pa3.vue?vue&type=script&lang=js"
export * from "./Pa3.vue?vue&type=script&lang=js"
import style0 from "./Pa3.vue?vue&type=style&index=0&id=1c36cfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36cfd2",
  null
  
)

export default component.exports